<ng-container *ngIf="showBreadcrumb">
    <ol class='breadcrumb col-12'>
        <li class="breadcrumb-item" *ngFor='let breadcrumb of breadcrumbLinksList; let i = index;'>
            <ng-container *ngIf="isPreviewMode; else clickableLink">
                <span>{{ breadcrumb.name }}</span> <!-- Display as plain text -->
            </ng-container>
            <ng-template #clickableLink>
                <a [routerLink]="breadcrumb.link" (click)="navigateURL(breadcrumb);">{{ breadcrumb.name }}</a> <!-- Clickable link -->
            </ng-template>
        </li>
    </ol>
</ng-container>